import { tokens } from "@cobee/cobee-ui";

// Chart colors
const chartColor1 = "#00f69e";
const chartColor2 = "#3d18a8";
const chartColor3 = "#68bda4";
const chartColor4 = "#a78cf5";
const chartColor5 = "#18a893";
const chartColor6 = "#facf38";
const chartColor7 = "#cce242";
const chartColor8 = "#0053f5";
const chartColor9 = "#42a870";
const chartColor10 = "#424ea8";

const customColors = {
  primary: tokens.palette.primary.main,
  primaryLight: tokens.palette.primary.light,
  secondary: tokens.palette.secondary.main,
  success: tokens.palette.success.main,
  warning: tokens.palette.warning.main,
  error: tokens.palette.error.main,
  black: tokens.palette.common.black,
  grey300: tokens.palette.grey[300],
  white: tokens.palette.common.white,
  messagesBackground: tokens.palette.secondary.light,
  lightGrey: tokens.palette.grey[50],
  tooltipShadow: "1px 1px 2px 0px rgba(212, 212, 212, 0.5)",
  chartColors: `${chartColor1},${chartColor2},${chartColor3},${chartColor4},${chartColor5},${chartColor6},${chartColor7},${chartColor8},${chartColor9},${chartColor10}`,

  // new palette
  newPaletteSecondary: "#1C2B78",
};

export const {
  primary,
  primaryLight,
  secondary,
  success,
  warning,
  error,
  black,
  grey300,
  white,
  messagesBackground,
  lightGrey,
  tooltipShadow,
  chartColors,
  newPaletteSecondary,
} = customColors;
